import { DOM } from './state.js';

/**
 * Sección de Eventos: encabezado "a medida" (en index.html) + este formulario de
 * consulta que abre WhatsApp prellenado. El carrusel de propuestas con precios
 * fijos se quitó — eran datos de relleno (fotos de stock + paquetes inventados)
 * que contradecían el "evento a medida".
 */
export function renderEventosForm() {
    if (!DOM.eventosForm) return;

    DOM.eventosForm.innerHTML = `
        <div class="bg-base rounded-[2.5rem] border border-border-subtle p-8 mt-4">
            <h3 class="text-lg font-black text-text-primary uppercase tracking-tight mb-6 text-center">Consultá por tu evento</h3>
            <form id="eventoConsultForm" class="space-y-5" autocomplete="off">
                <div class="text-left">
                    <label for="inputEventoNombre" class="text-[10px] font-black text-text-muted uppercase tracking-widest ml-4 mb-2 block">Nombre</label>
                    <input
                        type="text"
                        id="inputEventoNombre"
                        name="nombre"
                        placeholder="Tu nombre"
                        autocomplete="given-name"
                        class="w-full bg-surface border border-border-subtle rounded-2xl py-4 px-6 text-sm font-bold focus:border-brand focus:outline-none transition-colors"
                    >
                </div>
                <div class="text-left">
                    <label for="inputEventoApellido" class="text-[10px] font-black text-text-muted uppercase tracking-widest ml-4 mb-2 block">Apellido</label>
                    <input
                        type="text"
                        id="inputEventoApellido"
                        name="apellido"
                        placeholder="Tu apellido"
                        autocomplete="family-name"
                        class="w-full bg-surface border border-border-subtle rounded-2xl py-4 px-6 text-sm font-bold focus:border-brand focus:outline-none transition-colors"
                    >
                </div>
                <div class="text-left">
                    <label for="inputEventoPersonas" class="text-[10px] font-black text-text-muted uppercase tracking-widest ml-4 mb-2 block">Cantidad de personas</label>
                    <input
                        type="number"
                        id="inputEventoPersonas"
                        name="personas"
                        placeholder="Ej: 15"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        class="w-full bg-surface border border-border-subtle rounded-2xl py-4 px-6 text-sm font-bold focus:border-brand focus:outline-none transition-colors"
                    >
                </div>
                <button
                    type="button"
                    data-action="evento-consultar"
                    class="w-full py-5 bg-brand text-white rounded-2xl font-black uppercase tracking-widest text-xs shadow-lg active:scale-95 transition-transform flex items-center justify-center gap-3"
                >
                    <i class="fa-brands fa-whatsapp text-xl" aria-hidden="true"></i>
                    Consultar por WhatsApp
                </button>
            </form>
        </div>
    `;
}
